import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { Globals } from 'src/app/globals';

@Component({
  standalone: false,
  selector: 'app-patient-portal-appointment',
  templateUrl: './patient-portal-appointment.component.html',
  styleUrls: ['./patient-portal-appointment.component.scss']
})
export class PatientPortalAppointmentComponent implements OnInit {

  appointmentData: any = {};
  patientName: string = '';
  patientInformation: any = {};
  enumConfirmedStatus: string = '00000072-0000-0000-0000-000000000008';
  appointmentDate:moment.Moment;
  constructor(
    private readonly globals: Globals) { }

    ngOnInit(): void {
      this.appointmentData = JSON.parse(this.globals.appointmentData);
      this.patientInformation = JSON.parse(localStorage.getItem('storedPatient'));
      this.appointmentDate = moment(this.appointmentData.appointmentDate);      
    }

    print(){
      window.print();
    }
}
